<template>
  <div :id="`items-question_${indexQuestion}`">
    <!-- {{ values.answer || values.answers }} -->
    <div class="flex flex-col md:flex-row justify-between mt-6">
      <div
        @click="active = true"
        class="
          question
          bg-gray-100
          rounded-lg
          w-full
          md:w-1/3
          px-3
          h-10
          flex
          items-center
          flex
          justify-between
          cursor-pointer
          order-0
        "
      >
        <span class="truncate">{{ values.label }}</span>
        <div class="flex flex-col">
          <i class="material-icons p-0 m-0 bg-successf" style="font-size: 22px; line-height: 0.4"> arrow_drop_up </i>
          <i class="material-icons p-0 m-0 bg-successf" style="font-size: 22px; line-height: 0.4"> arrow_drop_down </i>
        </div>
      </div>
      <div
        :class="Order_1"
        class="
          type_condition
          bg-gray-100
          rounded-lg
          w-full
          md:w-1/3
          px-3
          h-10
          mx-0
          md:mx-2
          my-2
          md:my-0
          flex
          items-center
        "
      >
        {{ getType(values).type_condition }}
      </div>
      <div :class="Order_2" class="condition bg-gray-100 rounded-lg w-full md:w-1/3 h-10 flex items-center">
        <components
          :is="getType(values).component"
          v-if="values.name !== 'P_X' && values.hasOwnProperty('answer')"
          v-model="values.answer"
          :question="values"
          :key="values.name"
          :active="activeCompound"
        ></components>
        <components
          :is="getType(values).component"
          v-if="values.name !== 'P_X' && values.hasOwnProperty('answers')"
          v-model="values.answers"
          :question="values"
          :key="values.name"
          :active="activeCompound"
        ></components>
      </div>
      <div
        @click="deleteItem"
        class="
          Closed
          bg-gray-100
          rounded-lg
          px-0
          md:px-3
          flex
          items-center
          ml-0
          md:ml-2
          cursor-pointer
          text-center
          order-3
        "
      >
        <span class="hidden md:inline-block">X</span>
        <span class="inline-block md:hidden text-center bg-danger text-white w-full rounded-lg">Eliminar</span>
      </div>
    </div>
    <ListQuestion v-if="active" :active.sync="active" @question="values = $event"></ListQuestion>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ListQuestion from "./List-questions.vue";

import { Components } from "../components_/compound/index.js";

export default {
  components: { ListQuestion, ...Components },
  props: ["value", "activeCompound"],
  data() {
    return {
      answer: null,
      active: false
    };
  },
  watch: {
    "question.name": function () {
      this.answer = null;
    }
  },
  computed: {
    ...mapState("resource", ["indexQuestion", "questionsByPage"]),
    /**
     * Retorna un array con nombres de clases css
     */
    Order_1() {
      if (this.getType(this.values).component === "Boolean") {
        return ["order-2", "bg-white"];
      }
      return ["order-1"];
    },
    /**
     * Retorna un array con nombres de clases css
     */
    Order_2() {
      if (this.getType(this.values).component === "Boolean") {
        return ["order-1", "md:mx-2"];
      }
      return ["order-2"];
    },
    /**
     * Obtiene un objeto con las propiedades de la pregunta, del mismo modo configura las propiedades de la pregunta.
     */
    values: {
      get() {
        return this.value;
      },
      set(value) {
        const answer = value.inputType === "multi" || value.inputType === "multiOther" ? "answers" : "answer";
        const _value = value.inputType === "multi" || value.inputType === "multiOther" ? [] : null;
        const question = {
          name: value.name,
          [answer]: _value,
          type: value.type,
          inputType: value.inputType,
          label: value.label
        };

        if (value.hasOwnProperty("properties")) question.properties = value.properties;
        if (value.hasOwnProperty("options")) question.options = value.options;
        this.$emit("input", question);
      }
    }
  },
  methods: {
    deleteItem() {
      this.$emit("removeItem");
    },
    /**
     * Obtiene la estructura condicional según el tipo de pregunta para visualizar en la vista.
     * @param {object} question - Objeto con las propiedades de la pregunta.
     */
    getType(question) {
      switch (question.type) {
        case "boolean":
          return {
            type_condition: ``,
            component: "Boolean"
          };
        case "input": {
          return this.getInpuType(question.inputType);
        }
        case "choice": {
          return this.getInpuType(question.inputType);
        }
        case "photo": {
          return this.getInpuType(question.inputType);
        }
      }
    },
    /**
     * Obtiene la estructura condicional según la subtipo de pregunta para visualizar en la vista.
     * @param {string} inputType - El subtipo de pregunta.
     */
    getInpuType(inputType) {
      switch (inputType) {
        case "default":
        case "domain":
        case "phone":
        case "textarea":
        case "QRReader":
        case "ipv4":
        case "ipv6": {
          return {
            type_condition: `(Text) Igual a`,
            component: "Texto"
          };
        }
        case "password": {
          return {
            type_condition: `(Password) Igual a`,
            component: "Password"
          };
        }
        case "email": {
          return {
            type_condition: `(Email) Igual a`,
            component: "Email"
          };
        }
        case "slider": {
          return {
            type_condition: `(Slider) Igual a`,
            component: "Slider"
          };
        }
        case "ranking": {
          return {
            type_condition: `(Ranking) Igual a`,
            component: "Ranking"
          };
        }
        case "number": {
          return {
            type_condition: `(Número) Igual a`,
            component: "Number"
          };
        }
        case "currency": {
          return {
            type_condition: `(Valor) Igual a`,
            component: "Currency"
          };
        }
        case "radio":
        case "radioOther": {
          return {
            type_condition: `(Valor único) Igual a`,
            component: "UniqueChoice"
          };
        }
        case "multi":
        case "multiOther": {
          return {
            type_condition: `(Valor(es)) Igual a`,
            component: "MultiChoice"
          };
        }
        case "barcode": {
          return {
            type_condition: `(Código Barras) Igual a`,
            component: "Barcode"
          };
        }
        case "gallery":
        case "gallery/camera":
        case "camera": {
          return {
            type_condition: ``,
            component: "Boolean"
          };
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.bg-gray-100 {
  background-color: rgba(243, 244, 246, 1);
}
</style>
